import React from "react";
import InputForm from "./inputForm";

function App() {
  return <InputForm />;
}

export default App;
